// src/services/next-route.js
// La destination en attente, quand la connexion s'interpose.
//
// Un client qui scanne le QR de rattachement sans session arrive sur /login : sans mémoire de
// sa destination, il atterrit sur le tableau de bord et son code — qui vit dans le FRAGMENT de
// l'URL, donc nulle part ailleurs — est perdu. Il faut alors qu'il ressorte son courriel.
//
// La destination traverse jusqu'à DEUX écrans (connexion, puis changement de mot de passe à la
// première connexion, qui est justement le cas d'un client tout neuf). Elle passe donc par
// `sessionStorage` plutôt que d'être recopiée en paramètre d'URL d'écran en écran : un seul
// endroit la pose, un seul la consomme, et elle meurt avec l'onglet.
const CLE = 'ior:next';

// 🔴 Seul un chemin interne est accepté. `//ailleurs.example` commence bien par « / » mais
// c'est une URL protocole-relative : l'accepter ouvrirait une redirection vers un autre site
// depuis un lien de confiance.
const estInterne = v => typeof v === 'string' && /^\/(?!\/)/.test(v);

export function poser(valeur) {
  try { if (estInterne(valeur)) sessionStorage.setItem(CLE, valeur); } catch (e) { /* onglet privé */ }
}

// Consommer, et non lire : une destination ne doit servir qu'une fois.
export function consommer() {
  try {
    const v = sessionStorage.getItem(CLE);
    sessionStorage.removeItem(CLE);
    return estInterne(v) ? v : null;
  } catch (e) { return null; }
}

export function depuisUrl() {
  try {
    const v = new URLSearchParams(window.location.search).get('next');
    return estInterne(v) ? v : null;
  } catch (e) { return null; }
}

export default { poser, consommer, depuisUrl, estInterne };
